<section class="seller-container" *ngIf="!showError">
  <section class="ids-mv-6 ids-p-3">
    <section class="breadcrumb-box">
      <button idsActionButton (click)="backStep()">
        <ids-icon variant="primary">seta_esquerda</ids-icon>
        voltar
      </button>
      <p class="ids-color-text-highlight">etapa {{ currentStep }} / {{ totalSteps }}</p>
    </section>

    <section class="ids-pt-4">
      <ids-progress-bar weight="heavy" [fill]="percent"></ids-progress-bar>
    </section>

    <app-seller-step-one-pj
      *ngIf="currentStep === 1"
      (formsComplete)="reciverFormsComplete($event)"
      (dataForms)="receiverDataForms($event)"
      [dataCompany]="dataCompany"
    ></app-seller-step-one-pj>
    <app-seller-step-two-pj
      *ngIf="currentStep === 2"
      (formsComplete)="reciverFormsComplete($event)"
      (dataForms)="receiverDataForms($event)"
      [dataCompany]="dataCompany"
    ></app-seller-step-two-pj>
    <app-seller-step-three-pj
      *ngIf="currentStep === 3"
      (formsComplete)="reciverFormsComplete($event)"
      [dataCompany]="dataCompany"
      (dataForms)="receiverDataForms($event)"
    ></app-seller-step-three-pj>
    <app-seller-resume-pj
      *ngIf="currentStep === 4"
      (formsComplete)="reciverFormsComplete($event)"
      [dataCompany]="dataCompany"
    ></app-seller-resume-pj>

    <section class="ids-row ids-pt-7">
      <section class="ids-col-4">
        <button
          *ngIf="currentStep < totalSteps"
          (click)="goToNextStep()"
          [disabled]="buttonDisable"
          full
          idsMainButton
        >
          continuar
        </button>

        <button
          *ngIf="currentStep === 4"
          (click)="submitFormsPj()"
          [disabled]="buttonDisable"
          [loading]="loadingSaveForm"
          idsMainButton
          full
        >
          salvar formulário
        </button>
      </section>
    </section>
  </section>
</section>

<section class="seller-container">
  <section class="ids-mv-6 ids-p-3">
    <app-error-screen *ngIf="showError" (onClickTryAgain)="reciverTryAgain()"></app-error-screen>
  </section>
</section>

<app-modal-back-button [(openModal)]="showModalExit" (backFormEvent)="navigateFormList()"></app-modal-back-button>
